module.exports = __webpack_public_path__ + "0af5d249/img/upload-icon.9179ae4e.svg";